import React, { useEffect, useState } from 'react';
import PendingReceivables from "./components/receivable/PendingReceivables";
import Loading from "./core/Loading";
import { findPendingReceivablesByCustomerCompanyId } from "./utils/requestUtils";
import {getAuthToken} from "./utils/auth";
import {normalizeDate, UserPermission} from "./utils/utils";
import {usePermission} from "./core/PermissionContext";

const MainPage = ({ children }) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [pendingReceivables, setPendingReceivables] = useState(undefined);
    const [overdueReceivables, setOverdueReceivables] = useState(undefined);
    const [authToken, setAuthToken] = useState(undefined);
    const today = normalizeDate(new Date());
    const sixDaysLater = new Date(today);
    sixDaysLater.setDate(today.getDate() + 6);

    // Acompanha alterações da sessão (ex.: login concluído em outra aba) para
    // disparar a busca dos recebíveis pendentes assim que o usuário estiver autenticado.
    useEffect(() => {
        const interval = setInterval(() => {
            const token = getAuthToken();
            setAuthToken(prev => (prev !== token ? token : prev));
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        if (authToken) {
            findPendingReceivablesByCustomerCompanyId()
                .then(pending => {
                    const upcomingReceivables = pending.filter((p) => {
                        const dueDate = p.dueDate ? normalizeDate(new Date(p.dueDate)) : null;
                        return p.status === 0 && dueDate && dueDate >= today && dueDate <= sixDaysLater;
                    });
                    setPendingReceivables(upcomingReceivables);

                    const overdue = pending.filter(receivable => {
                        const dueDate = receivable.dueDate ? normalizeDate(new Date(receivable.dueDate)) : null;
                        return receivable.status === 0 && dueDate && dueDate < today;
                    });

                    setOverdueReceivables(overdue);
                });
        }
    }, [authToken]);


    if (
        authToken === undefined ||
        pendingReceivables === undefined ||
        overdueReceivables === undefined ||
        loadingPermissions
    ) {
        return <Loading />;
    }

    const getBoxStyle = (type) => {
        const isSmallScreen = window.innerWidth < 400;
        if (type === 'overdue') {
            return {
                alignItems: 'center',
                display: 'inline-block',
                width: isSmallScreen ? '80%' : '365px',
                marginLeft: isSmallScreen ? '5px' : null,
                border: '2px solid var(--alert-overdue-border)',
                backgroundColor: 'var(--alert-overdue-bg)',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '20px'
            };
        }
        if (type === 'pending') {
            return {
                alignItems: 'center',
                display: 'inline-block',
                width: isSmallScreen ? '80%' : '365px',
                marginLeft: isSmallScreen ? '5px' : null,
                border: '2px solid var(--alert-pending-border)',
                backgroundColor: 'var(--alert-pending-bg)',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '20px'
            };
        }
        return {};
    };

    return (
        <div className="main-page">
            {overdueReceivables.length > 0 && (
                <div style={getBoxStyle('overdue')}>
                    {hasUserPermission(UserPermission.ENABLE_PAY_COMPANY_RECEIVABLES) ?
                        <>
                            <h3 style={{color: 'var(--alert-overdue-text)'}}>
                                ⚠️ Você possui valores em atraso
                            </h3>
                            <PendingReceivables
                                overdueReceivables={overdueReceivables}
                                pendingReceivables={[]}
                            />
                        </>
                        :
                        <>
                            <h3 style={{color: 'var(--alert-overdue-text)'}}>
                                ⚠️ Entre em contato com o administrador do sistema.
                            </h3>
                        </>
                    }
                </div>
            )}

            {hasUserPermission(UserPermission.ENABLE_PAY_COMPANY_RECEIVABLES) && pendingReceivables.length > 0 && overdueReceivables.length === 0 && (
                <div style={getBoxStyle('pending')}>
                    <h3 style={{ color: 'var(--alert-pending-text)' }}>
                        🔔 Você possui débitos para os próximos dias
                    </h3>
                    <PendingReceivables
                        overdueReceivables={[]}
                        pendingReceivables={pendingReceivables}
                    />
                </div>
            )}

            {overdueReceivables.length === 0 && (
                <div className="main-page-content">{children}</div>
            )}

            {!children && overdueReceivables.length === 0 && pendingReceivables.length === 0 && (
                <>

                </>
            )}
        </div>
    );
};

export default MainPage;
